import { useMapPanelContext } from './MapPanelContext';
import { CENTERCOMPONENTS } from './CenterComponents';
import { ACTIVETAB, RIGHTSIDECOMPONENTS } from './RightSideComponents';
import { useResetDrawingContext } from '@ais-ui/react-openlayers';
import { useReportContext } from '../../Reports/ReportContext';
import { useCallback } from 'react';

export const useOnMapPanelExit = () => {
  const {
    navigateToTab,
    setRightSideComponent,
    centerComponent,
    setCenterComponent,
    setCenterComponentData,
    setTableExpanded,
  } = useMapPanelContext();

  const { resetReportContext } = useReportContext();

  const resetDrawingContext = useResetDrawingContext();

  const onExit = useCallback(() => {
    setCenterComponentData(null);
    if (
      centerComponent === CENTERCOMPONENTS.SHIPTABLE ||
      centerComponent === CENTERCOMPONENTS.ROUTES
    ) {
      setCenterComponent(CENTERCOMPONENTS.NONE);
    }

    setRightSideComponent(RIGHTSIDECOMPONENTS.NONE);
    navigateToTab(ACTIVETAB.NONE);
    resetDrawingContext();
    setTableExpanded(true);
    resetReportContext();
  }, [
    setCenterComponentData,
    setCenterComponent,
    setRightSideComponent,
    navigateToTab,
    resetDrawingContext,
    setTableExpanded,
    resetReportContext,
  ]);

  return onExit;
};
